<script>
  import Footer from './components/Footer.svelte';
  import Header from './components/Header.svelte';
  import SuggestionForm from './components/SuggestionForm.svelte';
  // Initialize the Telegram Web App
  Telegram.WebApp.ready();

  // Set up the theme
  /*$: {
    document.body.style.backgroundColor = Telegram.WebApp.themeParams.bg_color || '#ffffff';
    document.body.style.color = Telegram.WebApp.themeParams.text_color || '#000000';
  }*/

  // Handle closing the Web App
  function closeWebApp() {
    Telegram.WebApp.close();
  }  
</script>
<Header />

<div id="app">
  <main>
    <section class="section">
      <div class="container">
        <h3 class="is-3 label">Report a New Telegram Group to be indexed</h3>
        <SuggestionForm />
      </div>
    </section>
  </main>
  <Footer />
</div>

